import { render, staticRenderFns } from "./ReasonsList.vue?vue&type=template&id=fa359a74&scoped=true"
import script from "./ReasonsList.vue?vue&type=script&lang=js"
export * from "./ReasonsList.vue?vue&type=script&lang=js"
import style0 from "./ReasonsList.vue?vue&type=style&index=0&id=fa359a74&prod&lang=scss&scoped=true"
import style1 from "./ReasonsList.vue?vue&type=style&index=1&id=fa359a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa359a74",
  null
  
)

export default component.exports